export default __webpack_public_path__ + "static/media/img-help-essays.d3d7dfa2.png";